
<div class="commentsSection">
  <div class="topContainer">
    <h4>Your Comments</h4>
    <button type="button" class="gsd_close_btn2" aria-label="Close" mat-dialog-close><i class="material-symbols-outlined">close</i></button>
  </div>
  <div>
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label >Enter your comments</mat-label>
      <textarea matInput #userComment style="resize:none;" required maxlength="500"></textarea>
      <div class="commentCount">{{userComment.value.length}}/500</div>
    </mat-form-field>
    <div class="btns">
      <button class="custom_btn primary_btn_base mr-2" (click)="submit(userComment.value)" [disabled]="!userComment.value">Submit</button>
      <button class="custom_btn inverted_btn_base" mat-dialog-close>Close</button>
    </div>
  </div>
</div>